<template>
  <v-container class="primary-header">
    <div class="d-flex align-center mt-4 ga-3">
      <div class="text-h5 font-weight-bold text-md-h4 ps-1">{{ title }}</div>
      <slot name="status" />
      <v-spacer />
      <div class="d-flex align-center ga-3">
        <slot class="d-print-none" name="admin-hold-toggle" />
        <slot name="actions" />
      </div>
    </div>
  </v-container>
</template>

<script lang="ts" setup>
defineProps<{
  title: string;
  subtitle?: string;
  status?: string;
}>();
</script>

<style lang="scss" scoped>
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5.25rem;
  background: linear-gradient(rgb(var(--v-theme-background)) 75%, transparent);
  position: sticky;
  top: 0;
  z-index: 900;
}
.banner-escalate {
  display: flex;
  align-items: center;
  gap: 1rem;
  &--counter {
    font-variant-numeric: tabular-nums;
  }
}
@media print {
  .primary-header {
    color: black !important;
    max-width: 100%;
  }
}
</style>
